export default __webpack_public_path__ + "static/media/redbook2.edb4371f.jpg";